module.exports = __webpack_public_path__ + "static/media/_F7-Jest.f4863e2d.svg";